import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../public/error404/oops.jpg'

export const ErrorImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Something went wrong'} />
)
